import { SearchOutput, SearchUseCase } from './search-use-case';
import { GeneralSearchUseCase } from './general-search';
import { _userData, marketDataGateway } from '@core/market-data-sdk';
import { SearchItemEntity } from './entities/search-item';

export class GeneralSearchToPortfolio implements SearchUseCase {
  constructor(private portfolioId: string) {}

  async execute(term: string): Promise<SearchOutput> {
    let realIncomes: SearchItemEntity[] = [];
    let customAssets: SearchItemEntity[] = [];

    let [result, userRealIncomes, customAssetsResponse] = await Promise.all([
      GeneralSearchUseCase.getAssets(term, {
        include_old_tickers: true,
        adjusted: false,
        has_quotes: true,
      }),
      marketDataGateway.portfolio.getFixedIncomesByPortfolio({
        portfolioId: this.portfolioId,
      }),
      _userData.customAsset.list({ search: term }),
    ]);

    // Adiciona cotas como ativo por padrao por conta do adjusted=false (gambiarra de dados)
    result = result.map((item) => ({
      ...item,
      additional_fields: {
        ...item.additional_fields,
        has_quotes: true,
      },
    }));

    if (userRealIncomes?.asset_nicenames?.length) {
      realIncomes = userRealIncomes.asset_nicenames
        .filter((item) => item[1].toLowerCase().includes(term.toLowerCase()))
        .map(
          (item) =>
            new SearchItemEntity({
              identifier: item[0],
              nicename: item[1],
              type: 'Renda Fixa',
              canonical_url: null,
              additional_fields: {
                has_quotes: true,
              },
            })
        );
    }

    if (customAssetsResponse?.data) {
      customAssets = customAssetsResponse.data.map(
        (item) =>
          new SearchItemEntity({
            identifier: item.identifier,
            nicename: item.name,
            type: 'Ativos Personalizado',
            canonical_url: null,
            additional_fields: {
              has_quotes: true,
              trading_currency: item.currency,
            },
          })
      );
    }

    const formattedAssets = GeneralSearchUseCase.assetsFormatter(result);
    const groupedAssets = GeneralSearchUseCase.groupAssetsByCategory([
      ...formattedAssets,
      ...customAssets,
      ...realIncomes,
    ]);

    return groupedAssets;
  }
}
